import { EnumSchema } from '../metadata-schema';

export const IndicatorNaamPrestatieanalyse: EnumSchema = {
	"type": "string",
	"title": "IndicatorNaamPrestatieanalyse",
	"enum": [
		"Behaald niveau conform OPP",
		"Beoogd i.r.t. behaald einduitstroomniveau",
		"Tussentijdse uitstroom",
		"Einduitstroom"
	]
};
